import { TicketModel as y } from "./ticket.model.js";
import { Adapter as l, getAdapter as e } from "../../adapter.js";
import { TicketServiceAdapter as T } from "./ticketService/ticketService.adapter.js";
import { TicketSummaryAdapter as _ } from "./ticketSummary/ticketSummary.adapter.js";
import { TicketCashbackAdapter as v } from "./ticketCashback/ticketCashback.adapter.js";
import { TicketItemComboAdapter as H } from "./ticketItemCombo/ticketItemCombo.adapter.js";
import { TicketItemPromotionAdapter as b } from "./ticketItemPromotion/ticketItemPromotion.adapter.js";
import { TicketFeeAdapter as h } from "./ticketFee/ticketFee.adapter.js";
import { TicketTaxAdapter as D } from "./ticketTax/ticketTax.adapter.js";
import { TicketDeliveryAdapter as I } from "./ticketDelivery/ticketDelivery.adapter.js";
import { TicketItemAdapter as P } from "./ticketItem/ticketItem.adapter.js";
import { TicketHistoryDeliveryAdapter as S } from "./ticketHistory/ticketHistoryDelivery/ticketHistoryDelivery.adapter.js";
import { TicketHistoryPaymentAdapter as x } from "./ticketHistory/ticketHistoryPayment/ticketHistoryPayment.adapter.js";
import { TicketHistoryPosAdapter as C } from "./ticketHistory/ticketHistoryPos/ticketHistoryPos.adapter.js";
import { TicketHistoryRefundAdapter as g } from "./ticketHistory/ticketHistoryRefund/ticketHistoryRefund.adapter.js";
import { TicketHistoryStatusAdapter as w } from "./ticketHistory/ticketHistoryStatus/ticketHistoryStatus.adapter.js";
class W extends l {
  adapt(t) {
    var m, a, k, d, n;
    const r = e(I), o = e(h), c = e(P), p = e(H), s = e(b), i = e(v), f = e(_), A = e(T), u = e(D);
    return new y({
      channel: t.channel,
      id: t.id,
      status: t.status,
      name: t.name,
      created: new Date(t.created * 1e3),
      notes: t.notes,
      ticketSummary: f.adapt(t.ticket_summary),
      ticketDelivery: t.ticket_delivery ? r.adapt(t.ticket_delivery) : void 0,
      ticketCashback: t.ticket_cashback ? i.adapt(t.ticket_cashback) : void 0,
      ticketFees: ((m = t.ticket_fees) == null ? void 0 : m.map(o.adapt)) ?? [],
      ticketItemList: ((a = t.ticket_item_list) == null ? void 0 : a.map(c.adapt)) ?? [],
      ticketComboList: ((k = t.ticket_combo_list) == null ? void 0 : k.map(p.adapt)) ?? [],
      ticketPromotionList: ((d = t.ticket_promotion_list) == null ? void 0 : d.map(s.adapt)) ?? [],
      ticketTaxes: ((n = t.ticket_taxes) == null ? void 0 : n.map(u.adapt)) ?? [],
      ticketId: t.ticket_id,
      ticketNumber: t.ticket_number,
      ticketDatetime: new Date(t.ticket_datetime * 1e3),
      ticketService: t.ticket_service ? A.adapt(t.ticket_service) : void 0,
      assignedPos: t.assigned_pos,
      history: this.adaptHistory(t.history ?? []),
      scope: t.scope
    });
  }
  adaptHistory(t) {
    const r = e(w), o = e(S), c = e(C), p = e(x), s = e(g);
    return t.flatMap((i) => typeof i.status < "u" ? r.adapt(i.status) : typeof i.delivery < "u" ? o.adapt(i.delivery) : typeof i.pos < "u" ? c.adapt(i.pos) : typeof i.payment < "u" ? p.adapt(i.payment) : typeof i.refund < "u" ? s.adapt(i.refund) : []);
  }
  serialize(t) {
  }
}
export {
  W as TicketAdapter
};
//# sourceMappingURL=ticket.adapter.js.map
